/* Shared final-v6 IX2 frame clock. No work remains after the last owner unloads. */
(function () {
  if (window.XZV2FrameClock) return;
  var tick = null, frame = null, owners = 0;
  function advance(now) {
    tick = now;
    if (owners) frame = requestAnimationFrame(advance);
  }
  window.XZV2FrameClock = {
    acquire: function () {
      if (owners++ === 0) {
        tick = performance.now();
        frame = requestAnimationFrame(advance);
      }
      var active = true;
      return function () {
        if (!active) return;
        active = false;
        if (--owners === 0) {
          cancelAnimationFrame(frame);
          frame = null;
          tick = null;
        }
      };
    },
    now: function () { return tick === null ? performance.now() : tick; },
    optimizeFloat: function (value) {
      var rounded = Math.round(value * 100000) / 100000;
      return Math.abs(rounded) > 0.0001 ? rounded : 0;
    }
  };
})();
